var _style, _g, _path, _g2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.refer .st0{fill:#CECECE;}\n\t.refer .st1{fill:url(#SVGID_1_);}\n\t.refer .st2{fill:#FFFFFF;}\n\t.refer .st3{fill:url(#SVGID_00000107552225745170176060000014379595345196544425_);}\n\t.refer .st4{fill:url(#SVGID_00000138552445249759709160000000568880643998826412_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "refer"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.18,10.29c0-0.03,0-0.05,0-0.08l-1.44,2.52c0.51,0.06,1,0.22,1.44,0.44c0-0.05,0-0.11,0-0.16V10.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.99,7.04c0.59-0.36,1.28-0.58,2.02-0.58c0.7,0,1.35,0.19,1.91,0.52l-1.97-3.37L13.99,7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.83,10.29V13c0,0.03,0,0.06,0,0.09c0.44-0.21,0.93-0.34,1.44-0.39l-1.44-2.46 C19.82,10.26,19.83,10.27,19.83,10.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.67,21.96c0.59,0.23,1.13,0.57,1.59,1l-1.26-2.16C25.93,21.2,25.82,21.59,25.67,21.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.24,25.87l-1.43,2.5l1.39-0.01c-0.02-0.42-0.02-0.86-0.01-1.33c0-0.16,0-0.32,0-0.48 C3.2,26.32,3.21,26.09,3.24,25.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.05,22.7c0.35-0.28,0.74-0.52,1.17-0.69C6.1,21.74,6,21.45,5.94,21.15L5.05,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.33,28.22l-1.66-2.84c0.09,0.37,0.14,0.76,0.14,1.16c0,0.16,0,0.33,0,0.48c0,0.42,0,0.82-0.01,1.2 L30.33,28.22z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.7953,
    y1: 22.2501,
    x2: 18.0302,
    y2: 17.2032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.28,17.06c0-0.16,0.01-0.31,0.02-0.46c-0.41,0.15-0.85,0.23-1.31,0.23c-0.52,0-1.01-0.1-1.46-0.29 c0.02,0.17,0.03,0.35,0.03,0.52v3.16c0,0.72-0.18,1.41-0.49,2.01c0.8,0.44,1.46,1.09,1.92,1.88c0.43-0.75,1.06-1.38,1.8-1.81 c-0.33-0.62-0.52-1.32-0.52-2.07V17.06z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.82,13.74c0.06-0.23,0.09-0.48,0.09-0.73v-2.72c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91V13 c0,0.32,0.05,0.63,0.15,0.91c0.4,0.39,0.73,0.85,0.96,1.37c0.5,0.39,1.12,0.63,1.8,0.63c0.59,0,1.14-0.18,1.59-0.48 C17.86,14.78,18.29,14.19,18.82,13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.66,13.6c-1.91,0-3.46,1.55-3.46,3.46v3.16c0,0.61,0.16,1.19,0.44,1.69c0.51-0.18,1.06-0.28,1.64-0.28 h3.61c0.31,0,0.61,0.03,0.9,0.08c0.22-0.45,0.34-0.96,0.34-1.49v-3.16C25.11,15.15,23.56,13.6,21.66,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.21,13.6c-1.91,0-3.46,1.55-3.46,3.46v3.16c0,0.54,0.13,1.06,0.35,1.51c0.33-0.07,0.68-0.11,1.03-0.11 h3.61c0.53,0,1.04,0.09,1.52,0.24c0.27-0.49,0.42-1.05,0.42-1.65v-3.16C13.66,15.15,12.11,13.6,10.21,13.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056405888129733973980000014339402694383125947_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.6496,
    y1: 29.1654,
    x2: 14.5667,
    y2: 23.4398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056405888129733973980000014339402694383125947_)"
    },
    d: "M11.73,22.54H8.12 c-2.21,0-4.01,1.8-4.01,4.01c0,0.17,0,0.33,0,0.49c0,0.42,0,0.83,0.01,1.21h11.21c-0.04-0.38-0.02-0.73,0-1.06 c0.01-0.2,0.02-0.41,0.02-0.63c0-0.45,0.06-0.89,0.18-1.3C14.98,23.67,13.49,22.54,11.73,22.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047026823177114254840000011051034204761571238_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.3211,
    y1: 30.3202,
    x2: 25.8236,
    y2: 22.8176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047026823177114254840000011051034204761571238_)"
    },
    d: "M16.26,26.55c0,0.25-0.01,0.47-0.02,0.68 c-0.02,0.35-0.03,0.67,0.01,1.01h11.64c0.01-0.38,0.01-0.78,0.01-1.21c0-0.16,0-0.32,0-0.49c0-2.21-1.8-4.01-4.01-4.01h-3.61 C18.06,22.54,16.26,24.34,16.26,26.55z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.51,28.44l-5.48-9.39v-2c0-2.18-1.6-3.99-3.69-4.32l-6-10.28c-0.08-0.14-0.24-0.23-0.4-0.23 c-0.16,0-0.31,0.09-0.39,0.23L9.7,12.72c-2.17,0.25-3.86,2.1-3.86,4.34v2.43l-5.2,9.11c-0.08,0.14-0.08,0.32,0,0.46 c0.08,0.14,0.23,0.23,0.39,0.23c0,0,0,0,0,0l25.03-0.13h2.67l0-0.01l2.38-0.01c0.16,0,0.31-0.09,0.39-0.23 C31.6,28.76,31.59,28.59,31.51,28.44z M25.99,20.8l1.26,2.16c-0.46-0.43-0.99-0.77-1.59-1C25.82,21.59,25.93,21.2,25.99,20.8z  M25.11,17.06v3.16c0,0.53-0.12,1.04-0.34,1.49c-0.29-0.05-0.59-0.08-0.9-0.08h-3.61c-0.57,0-1.13,0.1-1.64,0.28 c-0.28-0.5-0.44-1.07-0.44-1.69v-3.16c0-1.91,1.55-3.46,3.46-3.46C23.56,13.6,25.11,15.15,25.11,17.06z M15.35,26.55 c0,0.22-0.01,0.43-0.02,0.63c-0.02,0.34-0.03,0.68,0,1.06H4.12c-0.01-0.38-0.01-0.78-0.01-1.21c0-0.16,0-0.32,0-0.49 c0-2.21,1.8-4.01,4.01-4.01h3.61c1.76,0,3.25,1.14,3.8,2.71C15.41,25.66,15.35,26.1,15.35,26.55z M14.09,22.22 c0.31-0.6,0.49-1.28,0.49-2.01v-3.16c0-0.18-0.01-0.35-0.03-0.52c0.45,0.19,0.94,0.29,1.46,0.29c0.46,0,0.9-0.08,1.31-0.23 c-0.02,0.15-0.02,0.31-0.02,0.46v3.16c0,0.75,0.19,1.45,0.52,2.07c-0.75,0.44-1.37,1.06-1.8,1.81 C15.55,23.31,14.89,22.66,14.09,22.22z M13.09,13v-2.72c0-1.6,1.31-2.91,2.91-2.91c1.6,0,2.91,1.31,2.91,2.91V13 c0,0.25-0.03,0.5-0.09,0.73c-0.53,0.46-0.96,1.04-1.22,1.7c-0.46,0.3-1.01,0.48-1.59,0.48c-0.68,0-1.31-0.24-1.8-0.63 c-0.23-0.52-0.56-0.98-0.96-1.37C13.14,13.63,13.09,13.32,13.09,13z M21.26,12.71c-0.51,0.05-0.99,0.18-1.44,0.39 c0-0.03,0-0.06,0-0.09v-2.72c0-0.01,0-0.03,0-0.04L21.26,12.71z M15.95,3.61l1.97,3.37C17.35,6.65,16.7,6.46,16,6.46 c-0.74,0-1.43,0.21-2.02,0.58L15.95,3.61z M12.18,10.21c0,0.03,0,0.05,0,0.08V13c0,0.05,0,0.11,0,0.16 c-0.44-0.22-0.93-0.38-1.44-0.44L12.18,10.21z M6.75,17.06c0-1.91,1.55-3.46,3.46-3.46c1.91,0,3.46,1.55,3.46,3.46v3.16 c0,0.6-0.15,1.16-0.42,1.65c-0.48-0.16-0.99-0.24-1.52-0.24H8.12c-0.35,0-0.7,0.04-1.03,0.11c-0.22-0.46-0.35-0.97-0.35-1.51V17.06 z M5.94,21.15c0.07,0.3,0.16,0.58,0.28,0.85C5.8,22.18,5.4,22.42,5.05,22.7L5.94,21.15z M1.82,28.37l1.43-2.5 c-0.03,0.22-0.05,0.45-0.05,0.68c0,0.16,0,0.33,0,0.48c0,0.46,0,0.91,0.01,1.33L1.82,28.37z M27.89,28.24H16.25 c-0.04-0.35-0.02-0.66-0.01-1.01c0.01-0.21,0.02-0.44,0.02-0.68c0-2.21,1.8-4.01,4.01-4.01h3.61c2.21,0,4.01,1.8,4.01,4.01 c0,0.17,0,0.33,0,0.49C27.9,27.46,27.9,27.87,27.89,28.24z M28.8,28.23c0.01-0.38,0.01-0.78,0.01-1.2c0-0.16,0-0.32,0-0.48 c0-0.4-0.05-0.79-0.14-1.16l1.66,2.84L28.8,28.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.aa5b6b4f6a7ecea7f7943f4b2d0de41f.svg";
export { ForwardRef as ReactComponent };